import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { BASE_URL_USER } from '../../config/constant';

const HomeGuard = ({ children }) => {

    const account = useSelector((state) => state.account);

    const lista = ['administrador', 'compras'];

    let result = false
    account.data["cognito:groups"].forEach( element => {
        if(lista.includes(element)){
            result = true
        }
    })

    if(result){
        return children;
    } else {
        return <Navigate to={BASE_URL_USER} /> 
    }

};

export default HomeGuard;
